// Share story
import { apiAxios } from "../apiConfig";
export const shareStory = async (payload) => {
  try {
    const response = await apiAxios.post("/stories", payload);
    return response.data;
  } catch (error) {
    console.error("Error sharing story:", error);
    throw error;
  }
};
